(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
/* S-Rank: independent arrows for featured-collection product rows.
   Keep Prestige's scroll-carousel for native scrolling, dragging and tabs.
   Only these two arrows use our own scroll position; no theme.js patch. */
(() => {
  const selector = '[data-sr-carousel-controls]';
  const controllers = new WeakMap();
  const clamp = (value, maximum) => Math.max(0, Math.min(maximum, value));
  const pixels = (value, width) => (parseFloat(value) || 0) * (value.endsWith('%') ? width / 100 : 1);

  class ProductRowControls {
    constructor(root) {
      this.root = root;
      this.carousel = root.querySelector('[data-sr-product-carousel]');
      this.buttons = Array.from(root.querySelectorAll('button[data-sr-carousel-step]'));
      this.frame = 0;
      this.pending = null;
      this.timer = 0;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          if (this.root.isConnected) this.update();
        });
      };
      this.cancelPending = () => {
        this.pending = null;
        clearTimeout(this.timer);
      };

      /* Native buttons, not Prestige's carousel-next/prev custom elements:
         exactly one click handler owns the movement. */
      root.addEventListener('click', (event) => {
        const button = event.target instanceof Element
          ? event.target.closest('button[data-sr-carousel-step]') : null;
        if (!button || !this.buttons.includes(button)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!button.disabled) this.move(Number(button.dataset.srCarouselStep));
      }, { capture: true, signal });

      this.carousel.addEventListener('scroll', this.schedule, { passive: true, signal });
      this.carousel.addEventListener('scrollend', () => {
        this.cancelPending();
        this.schedule();
      }, { signal });
      ['wheel', 'touchstart', 'pointerdown'].forEach((name) => {
        this.carousel.addEventListener(name, this.cancelPending, { passive: true, signal });
      });
      root.addEventListener('load', this.schedule, { capture: true, signal });
      window.addEventListener('resize', () => {
        this.cancelPending();
        this.schedule();
      }, { passive: true, signal });

      /* Recalculate after a hidden Women/Men tab becomes visible. */
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.schedule);
        this.resizeObserver.observe(root);
        this.resizeObserver.observe(this.carousel);
      }
      this.mutationObserver = new MutationObserver(this.schedule);
      this.mutationObserver.observe(this.carousel, { childList: true });
      const panel = root.closest('.featured-collections-carousel__item');
      if (panel) {
        this.mutationObserver.observe(panel, {
          attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']
        });
      }
      this.update();
    }

    metrics() {
      const carousel = this.carousel;
      const style = getComputedStyle(carousel);
      const rtl = style.direction === 'rtl';
      const maximum = Math.max(0, carousel.scrollWidth - carousel.clientWidth);
      const position = clamp(rtl ? -carousel.scrollLeft : carousel.scrollLeft, maximum);
      const rect = carousel.getBoundingClientRect();
      const startPadding = pixels(style.scrollPaddingInlineStart, carousel.clientWidth);
      const endPadding = pixels(style.scrollPaddingInlineEnd, carousel.clientWidth);
      const startEdge = rect.left + carousel.clientLeft;
      const endEdge = startEdge + carousel.clientWidth;
      const cards = Array.from(carousel.children)
        .filter((element) => element instanceof HTMLElement && !element.hidden)
        .map((element) => ({ element, rect: element.getBoundingClientRect() }))
        .filter((card) => card.rect.width > 0);
      const positions = cards.map((card) => position +
        (rtl ? endEdge - card.rect.right : card.rect.left - startEdge) - startPadding);
      const stride = positions.length > 1 ? Math.abs(positions[1] - positions[0]) : carousel.clientWidth;
      const gap = cards.length ? Math.max(0, stride - cards[0].rect.width) : 0;
      const usable = Math.max(1, carousel.clientWidth - startPadding - endPadding);
      const perPage = Math.max(1, Math.floor((usable + gap + 1) / Math.max(1, stride)));
      return {
        rtl, maximum, position, cards,
        step: Math.max(1, stride * perPage),
        stops: [...new Set([0, ...positions.map((value) => clamp(value, maximum)), maximum])]
      };
    }

    update() {
      const metrics = this.metrics();
      const visible = this.carousel.clientWidth > 0 && this.carousel.getClientRects().length > 0;
      const overflow = visible && metrics.maximum > 2;
      this.buttons.forEach((button) => {
        const previous = Number(button.dataset.srCarouselStep) < 0;
        const disabled = !overflow || (previous ? metrics.position <= 2 : metrics.position >= metrics.maximum - 2);
        button.disabled = disabled;
        button.setAttribute('aria-disabled', String(disabled));
        button.closest('[data-sr-carousel-control]').hidden = !overflow;
      });
      if (this.pending !== null && Math.abs(metrics.position - this.pending) <= 2) this.cancelPending();
      if (visible && metrics.cards.length) {
        const first = metrics.cards[0].element;
        const media = first.querySelector('.product-card__media') || first;
        const imageRect = media.getBoundingClientRect();
        const top = imageRect.top - this.root.getBoundingClientRect().top + imageRect.height / 2;
        this.root.style.setProperty('--sr-carousel-controls-top', `${top}px`);
      }
    }

    move(direction) {
      const metrics = this.metrics();
      if (!metrics.maximum || !this.carousel.clientWidth) return;
      const base = this.pending === null ? metrics.position : clamp(this.pending, metrics.maximum);
      const goal = clamp(base + direction * metrics.step, metrics.maximum);
      const candidates = metrics.stops.filter((stop) => direction > 0 ? stop > base + 1 : stop < base - 1);
      const target = candidates.length
        ? candidates.reduce((nearest, stop) => Math.abs(stop - goal) < Math.abs(nearest - goal) ? stop : nearest)
        : goal;
      this.pending = target;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.cancelPending();
        this.schedule();
      }, 1000);
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.carousel.scrollTo({
        left: metrics.rtl ? -target : target,
        behavior: reducedMotion ? 'instant' : 'smooth'
      });
      this.schedule();
    }

    destroy() {
      this.abort.abort();
      this.resizeObserver?.disconnect();
      this.mutationObserver.disconnect();
      cancelAnimationFrame(this.frame);
      this.cancelPending();
    }
  }

  function rowsWithin(scope) {
    const rows = Array.from(scope.querySelectorAll(selector));
    if (scope instanceof Element && scope.matches(selector)) rows.unshift(scope);
    return rows;
  }
  function initialize(scope) {
    rowsWithin(scope).forEach((root) => {
      if (controllers.has(root)) return;
      if (!root.querySelector('[data-sr-product-carousel]') ||
          root.querySelectorAll('button[data-sr-carousel-step]').length !== 2) return;
      controllers.set(root, new ProductRowControls(root));
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    rowsWithin(event.target).forEach((root) => {
      controllers.get(root)?.destroy();
      controllers.delete(root);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
